
import { ratings } from '../customWhiteLabel'
export default {
  layout: 'e-commerce',
  data() {
    return {
      rating: 5,
      colorGradient: '',
    }
  },
  head() {
    return {
      title: 'Empresa',
    }
  },
  computed: {
    randomReport() {
      let randomIndex
      do {
        randomIndex = Math.floor(Math.random() * ratings.length)
      } while (randomIndex === this.noticiaAtualIndex)
      return ratings[randomIndex]
    },
  },
}
